import {JumpTag} from "../model/data/JumpTag";
import {CrudApi} from "./CrudApi";

export class JumpTagApi extends CrudApi<JumpTag> {
    constructor() {
        super('/jump_tag', JumpTag.prototype);
    }
}
